/* Osmero (homepage) – volitelný detail dlaždice v modal okně.
 * Dlaždice s [data-osmero-modal] otevře #osmero-modal-<i>.
 * Zavírá křížek/backdrop ([data-osmero-zavrit]) a Escape.
 * Klik na odkaz uvnitř dlaždice (CTA) modal neotevírá — naviguje. */
(function () {
	function zavritVse() {
		var otevrene = document.querySelectorAll('.osmero-modal.open');
		for (var i = 0; i < otevrene.length; i++) {
			otevrene[i].classList.remove('open');
			otevrene[i].setAttribute('aria-hidden', 'true');
		}
		if (otevrene.length) document.body.style.overflow = '';
	}

	function otevrit(dlazdice) {
		var m = document.getElementById('osmero-modal-' + dlazdice.getAttribute('data-osmero-modal'));
		if (!m) return;
		m.classList.add('open');
		m.setAttribute('aria-hidden', 'false');
		document.body.style.overflow = 'hidden';
	}

	document.addEventListener('click', function (e) {
		if (e.target.closest('[data-osmero-zavrit]')) { zavritVse(); return; }
		var dlazdice = e.target.closest('[data-osmero-modal]');
		if (dlazdice && !e.target.closest('a')) otevrit(dlazdice);
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') { zavritVse(); return; }
		if (e.key === 'Enter' || e.key === ' ') {
			var dlazdice = e.target.closest ? e.target.closest('[data-osmero-modal]') : null;
			if (dlazdice) { e.preventDefault(); otevrit(dlazdice); }
		}
	});
})();
